import { TypedTFunction, translations } from '../models';

export function getLockoutString(lockoutValue: any, translation: TypedTFunction<typeof translations>): string {
    return lockoutValue === '0' ? translation('NO_LOCKOUT') : `${lockoutValue} ${translation('LOCK_ATTEMPTS_PLURAL')}`;
}